"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IntroPage = void 0;
const index_1 = require("../../../../index");
const react_1 = __importDefault(require("react"));
const fullStory_1 = require("../../../../util/fullStory");
const Heading_1 = require("../../heading/Heading");
const Paragraph_1 = require("../../paragraph/Paragraph");
const Spacer_1 = require("../../spacer/Spacer");
const IntroPage = () => {
    const { propertyId } = react_1.default.useContext(index_1.AppContext);
    react_1.default.useEffect(() => {
        (0, fullStory_1.sendCustomFullStoryEvent)('smart_pricing_info_modal_viewed', {
            property_id: propertyId,
        });
    }, []);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Heading_1.HeadingSmall, null, "Less demanding, more rewarding"),
        react_1.default.createElement(Spacer_1.Spacer, { spacing: "small" }),
        react_1.default.createElement(Paragraph_1.Paragraph, null, "Smart pricing scans the market to understand when properties in your area are in demand and adjusts your prices to set smart, competitive rates."),
        react_1.default.createElement(Spacer_1.Spacer, { spacing: "small" }),
        react_1.default.createElement(Paragraph_1.Paragraph, null, "This means you could earn up to 60% more revenue all while doing less work!")));
};
exports.IntroPage = IntroPage;
//# sourceMappingURL=IntroPage.js.map